import { render } from "./NewTicketOption.vue?vue&type=template&id=593a87ae&scoped=true&ts=true"
import script from "./NewTicketOption.vue?vue&type=script&lang=ts"
export * from "./NewTicketOption.vue?vue&type=script&lang=ts"

import "./NewTicketOption.vue?vue&type=style&index=0&id=593a87ae&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-593a87ae"]])

export default __exports__